var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table-column',{attrs:{"label":_vm.label,"type":"index","width":"60"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _c('span',{},[_c('cell-inner',{key:_vm.getKey(),attrs:{"data":scope}})],1)}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }